module.exports = __webpack_public_path__ + "39e69f5af98df78ffb0518ffa6892764.svg";